import {
  changeSurveyPreferencesConstants,
  globalConstants,
} from "../../constants";

// default state
const initialState = {
  surveyPreferences: null,
};

//Manupilating the state based on actions and returning the state
export const changeSurveyPreferencesReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case changeSurveyPreferencesConstants.GET_SURVEY_PREFERENCES +
      globalConstants.SUCCESS:
    case changeSurveyPreferencesConstants.GET_SURVEY_PREFERENCES +
      globalConstants.FAILURE:
      return {
        ...state,
        surveyPreferences: action?.data,
      };
    default:
      return state;
  }
};
